import { render, staticRenderFns } from "./Protected.vue?vue&type=template&id=aea0a838"
import script from "./Protected.vue?vue&type=script&lang=js"
export * from "./Protected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea0a838')) {
      api.createRecord('aea0a838', component.options)
    } else {
      api.reload('aea0a838', component.options)
    }
    module.hot.accept("./Protected.vue?vue&type=template&id=aea0a838", function () {
      api.rerender('aea0a838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Protected.vue"
export default component.exports